import React from 'react';
import { minBy } from 'lodash';
import { useElementSize } from 'taboola-ultimate-ui';
import { ChatAgentButtonBase } from 'components/ChatAgent/components/ChatAgentButtonBase/ChatAgentButtonBase';
import { CAMPAIGN_STATUS, ENTITY } from 'modules/campaigns/config';
import { PERFORMANCE_RECOMMENDATIONS } from 'modules/campaigns/modules/performance-recommendations/config/performanceRecommendations';
import { useRibbonRecommendation } from 'modules/campaigns/modules/performance-recommendations/hooks/useRibbonRecommendation';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useChatAgentRecommendationsPermission } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useChatAgentRecommendationsPermission';
import styles from './fixCampaignWithAiButton.module.scss';

const { CAMPAIGN_UNDERPERFORMING, CAMPAIGN_LOSING_AUCTIONS } = PERFORMANCE_RECOMMENDATIONS;
const RECOMMENDATIONS_PRIORITY = [CAMPAIGN_LOSING_AUCTIONS, CAMPAIGN_UNDERPERFORMING];
const FULL_MODE_WIDTH = 126;

export const FixCampaignWithAiButton = ({ campaignData, entityType }) => {
    const { width, ref: containerRef } = useElementSize();
    const { id } = campaignData;
    const { accountId } = useAccount();
    const { ribbonRecommendations } = useRibbonRecommendation(accountId);

    const campaignRecommendations =
        ribbonRecommendations?.filter(recommendation => recommendation?.campaignId === id) || [];
    const recommendation = minBy(campaignRecommendations, rec => RECOMMENDATIONS_PRIORITY.indexOf(rec.type));

    const isPermitted = useChatAgentRecommendationsPermission({
        recommendations: recommendation ? [recommendation] : [],
    });
    const isPaused = campaignData.status === CAMPAIGN_STATUS.PAUSED || !campaignData.isActive;
    const isCompactMode = width < FULL_MODE_WIDTH;

    if (!recommendation || !isPermitted || entityType !== ENTITY.CAMPAIGN || isPaused) {
        return null;
    }

    return (
        <div className={styles['container']} ref={containerRef} aria-label="Fix With Abby">
            <ChatAgentButtonBase
                eventData={{ recommendation }}
                id={recommendation.type}
                agentName={recommendation.type.toLowerCase()}
                messageId="abby.underperforming.campaign"
                className={styles['button-container']}
                isCompactMode={isCompactMode}
            />
        </div>
    );
};
